module.exports = __webpack_public_path__ + "static/media/icefox-logo.02db27e0.png";